import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';


 
function getStoreWiseProductCatalogueDetailsService(token,data) {
    return axios.post(`${CURRENT_API_URL}/campaign/getStoreWiseProductCatalogueDetails`,data, {
        
        headers: {
            'Authorization': token,
        },
    }).then((res) => {
        const response = res.data;

        console.log("API RESPONSE:", response);

        // CASE 1: LARGE DATA (>5000)
        if (response && response.status === "processing") {
            notify.NotifyWarning(response.message);
            return response;
        }

        //CASE 2: SUCCESS (<5000)
        if (response && response.status === "success") {
            notify.NotifySuccess("Product Catalogue Details fetched successfully.");
            return response;
        }

        //CASE 3: BACKEND ERROR
        if (response && response.status === "error") {
            notify.NotifyError(response.message || "Something went wrong.");
            return null;
        }

        // CASE 4: UNKNOWN / EMPTY
        notify.NotifyWarning
            ? notify.NotifyWarning("Product Catalogue Details not available.")
            : notify.NotifySuccess("Product Catalogue Details not available.");

        return null;
    })
    .catch((err) => {
        console.error("AXIOS ERROR:", err);

        notify.NotifyError("Error while fetching Product Catalogue Details.");
        return null;
    });
}

export default getStoreWiseProductCatalogueDetailsService;